export function findSkus (t, sku, key, locals) {
  // TODO harmoniser cette condition avec celle des sacs singles
  const skusToExclude = [
    'CF.GRAND.FROID.BB.T0',
    'CF.GRAND.FROID.BB.T1',
    'CF.VANITY.T44.CHEV',
    'CF.VANITY.T42.CHEV',
    'CF.VANITY.T40.CHEV',
    'CF.VANITY.T38.CHEV',
    'CF.VANITY.T36.CHEV'
  ]
  if (skusToExclude.includes(sku)) {
    const _sku = sku.replace(/\.(PE.)*|\.|-/g, '')
    const i18nContent = t(`${locals}:${_sku}:${key}`, { returnObjects: true })

    return i18nContent !== `${_sku}.${key}` && i18nContent
  }

  const SKU = sku.replace(/(\b(PE\.|IDV\.)*)T[0-9]|\.|-/g, '')
  const i18nContent = t(`${locals}:${SKU}:${key}`, { returnObjects: true })

  return i18nContent !== `${SKU}.${key}` && i18nContent
}

export const SIZE_INFO = {
  diapers: [
    {
      index: 1,
      name: 'T1',
      weightRange: [2, 4],
      nbDiapers: 60,
      img: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_t1_f3c23d15-1671-46a8-b7fa-e7485a5ff059.svg?v=1649164491',
      imgSelected: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_T1.svg?v=1648047252',
      mixStepLight: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_pale-05.svg?v=1621268140',
      mixStepDark: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-05.svg?v=1621268170',
      mixStepGray: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_gris-05.svg?v=1621268192'
    },
    {
      index: 2,
      name: 'T2',
      weightRange: [3, 5],
      nbDiapers: 64,
      img: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_t2_a6109612-85ad-4e3c-8d34-e0971afeaba1.svg?v=1649164502',
      imgSelected: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_T2.svg?v=1648047252',
      mixStepLight: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_pale-06.svg?v=1621268140',
      mixStepDark: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-06.svg?v=1621268167',
      mixStepGray: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_gris-06.svg?v=1621268191'
    },
    {
      index: 3,
      name: 'T3',
      weightRange: [4, 8],
      nbDiapers: 54,
      img: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_t3_b068085f-66c0-498a-a2ab-8788a502404c.svg?v=1649164620',
      imgSelected: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_T3.svg?v=1648047252',
      mixStepLight: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_pale-07.svg?v=1621268140',
      mixStepDark: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-07.svg?v=1621268170',
      mixStepGray: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_gris-07.svg?v=1621268192'
    },
    {
      index: 4,
      name: 'T4',
      weightRange: [7, 14],
      nbDiapers: 48,
      img: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_t4_d7099802-f190-4a33-9ac3-1353e8024310.svg?v=1649164632',
      imgSelected: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_T4.svg?v=1648047252',
      mixStepLight: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_pale-04.svg?v=1621268140',
      mixStepDark: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-08.svg?v=1621268167',
      mixStepGray: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_gris-04.svg?v=1621268191'
    },
    {
      index: 5,
      name: 'T5',
      weightRange: [10, 18],
      nbDiapers: 40,
      img: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_t5_a0490f23-50b3-49a3-ac50-3341e5cc5e28.svg?v=1649164643',
      imgSelected: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_T5.svg?v=1648047252',
      mixStepLight: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_pale-08.svg?v=1621268141',
      mixStepDark: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-04.svg?v=1621268170',
      mixStepGray: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_gris-08.svg?v=1621268191'
    },
    {
      index: 6,
      name: 'T6',
      weightRange: [16, 30],
      nbDiapers: 38,
      img: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_t6_4069391e-92a3-43dc-818d-da83fc619ac0.svg?v=1649164653',
      imgSelected: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_T6.svg?v=1648047252',
      mixStepLight: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_pale-09.svg?v=1621268141',
      mixStepDark: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-09.svg?v=1621268170',
      mixStepGray: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_gris-09.svg?v=1621268191'
    }
  ],
  pants: [
    {
      index: 1,
      name: 'T4',
      weightRange: [8, 14],
      nbDiapers: 30,
      img: 'https://cdn.shopify.com/s/files/1/1956/4693/files/pant_t4.svg?v=1649163245',
      imgSelected: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-10.svg?v=1619785409',
      mixStepLight: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_pale-10_617287b1-e7d3-4973-beed-6b28f55bad43.svg?v=1621268140',
      mixStepDark: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-10_d038b4ad-6d53-4529-8e4d-a5201f710a0f.svg?v=1621268167',
      mixStepGray: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_gris-10.svg?v=1621268191'
    },
    {
      index: 2,
      name: 'T5',
      weightRange: [12, 18],
      nbDiapers: 28,
      defaultValue: true,
      img: 'https://cdn.shopify.com/s/files/1/1956/4693/files/pant_t5.svg?v=1649163258',
      imgSelected: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-11.svg?v=1619785409',
      mixStepLight: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_pale-11_a7e90160-c9d5-4930-9351-1c1cc6679374.svg?v=1621268141',
      mixStepDark: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-11_7d6565b0-617c-4df5-85b6-c96323088209.svg?v=1621268167',
      mixStepGray: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_gris-11.svg?v=1621268191'
    },
    {
      index: 3,
      name: 'T6',
      weightRange: [16, 30],
      nbDiapers: 26,
      img: 'https://cdn.shopify.com/s/files/1/1956/4693/files/pant_t6.svg?v=1649163269',
      imgSelected: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-12.svg?v=1619785409',
      mixStepLight: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_pale-12_af89e075-a716-455a-a440-83ba14142b64.svg?v=1621268141',
      mixStepDark: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_fonce-12_e3e0d8cf-7ec8-4c04-b146-467b783c3906.svg?v=1621268170',
      mixStepGray: 'https://cdn.shopify.com/s/files/1/1956/4693/files/couche_gris-12.svg?v=1621268191'
    }
  ]
}

export const PACK_NUMBER = {
  diapers: 3,
  pants: 4,
  mix: {
    diapers: 1,
    pants: 3
  }
}

export const PRODUCT_CATEGORIES = {
  pants: 'pant',
  diapers: 'diaper'
}

export const BUNDLE_TYPES = {
  DIAPERS: 'diapers',
  PANTS: 'pants',
  MIX: 'mix'
}

export const BUNDLE_TYPE_TO_SKU = {
  diapers: 'JOONECHARGE.BUNDLE.C.V1',
  pants: 'JOONECHARGE.BUNDLE.CC.V1',
  mix: 'JOONECHARGE.BUNDLE.CC.C.V1',
  one: 'JOONECHARGE.BUNDLE.C.ONE.V1',
  origin: 'JOONECHARGE.BUNDLE.C.ORI.V1'
}

/**
 * Used to prefetch reviews from trustpilot for a given SKU
 * @param sku
 * @return {Promise<[]>}
 */
export async function bundlePredicate (sku) {
  const baseURL = 'https://api.trustpilot.com/v1/product-reviews/business-units'
  const businessUnit = document.querySelector('meta[name="trustpilot_businessunit_id"]').content
  const apiKey = document.querySelector('meta[name="trustpilot_api_key"]').content

  const trustPilotReviews = await fetch(`${baseURL}/${businessUnit}?apikey=${apiKey}&sku=${sku}`).then(res => res.json())
  const looxReviews = await fetch(`${baseURL}/${businessUnit}/imported-reviews-summaries?apikey=${apiKey}&sku=${sku}`).then(res => res.json())

  return [trustPilotReviews, looxReviews]
}

export function hasRequiredThemeSettings (metas) {
  return metas.every(meta => !!themeSettingMeta(meta))
}

export function themeSettingMeta (name) {
  return document.querySelector(`meta[name="${name}"]`)?.content
}

export function windowAmplitudeTrack (eventName, properties = {}) {
  if (typeof amplitudeTrack === 'function') {
    /* global amplitudeTrack */
    amplitudeTrack(eventName, properties)
  } else {
    console.log('missing amplitudeTrack definition expected in amplitude.liquid')
  }
}

export function urlHas (string) {
  return window.location.href.includes(string)
}

export function isGermanDomain () {
  return window.location.hostname.endsWith('.de')
}
